Vue.component('retrieve-agent-session-closed', {
	props: ['options','labellang'],
	template:	'<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">'+
					'<div id="retrieve-agent-session-closed">'+
							'<div class="overlay-content">'+
								'<h3 class="text-center"> {{ text.paragraph }} </h3>'+
							'</div>'+
							'<div class="overlay-footer">'+
								'<button @click="closeView" class="btn pull-left" data-language="cancel" data-language-type="text"> {{ text.btn.cancel }} </button>'+
								'<button @click="liveSupport" class="btn btn-info pull-rigth" data-language="send" data-language-type="text" > {{ text.btn.send }} </button>'+
							'</div>'+
					'</div>'+
				'</transition>',
	data:function(){
		return {
			isActive:false,
			isSendDisable:false,
            text: {
                paragraph: this.labellang.retrieve_session_closed_new_agent,
                btn: {
                    send: this.labellang.retrieve_session_closed_new_agent_button,
                    cancel: this.labellang.retrieve_session_closed_new_agent_nothanks
                }
            }
		}
	},
	mounted: function() {
		var that = this;
		this.$parent.$on('onRetrieveAgentSessionClosed', function (val) {
			that.contentShow(val);
		})
	},
	methods:{
		contentShow:function(val){
			this.isActive = val;
		},
		closeView:function(){
			// this.options.internal.requestCloseReason = "customer";
			// this.options.internal.requestCloseFromCustomer = true;
			// this.options.internal.haveAlreadySessionActive = false;
			 this.$parent.closeSession();
			// this.isActive = false;


			this.$parent.sendMessageToParent({command: this.options.ExternalCommands.NOTACTIVECHAT});
			this.$parent.sendMessageToParent({command: this.options.ExternalCommands.COLLAPSE});
		},
		liveSupport:function(){
    	this.$parent.showLoading(true);
			this.$parent.sendMessageToParent({command: this.options.ExternalCommands.NOTACTIVECHAT});
			this.options.internal.haveAlreadySessionActive = false;
			this.$parent.requestServiceConfiguration()
			this.isActive = false;
		}
	},
})
